import { styled } from '@mui/material/styles';
import { createTheme } from '@mui/material';
import PaperBase from '@mui/material/Paper';

export const datePickerTheme = createTheme({
  components: {
    MuiYearCalendar: {
      styleOverrides: {
        root: {
          maxHeight: '305px !important'
        }
      }
    },
    MuiPickersYear: {
      styleOverrides: {
        root: {
          flexBasis: '100% !important',
          maxWidth: '100% !important',
          justifyContent: 'center',
          height: '40px',
          '&:has(.Mui-selected)': {
            margin: '10px 0'
          }
        },
        yearButton: {
          width: '100%',
          height: '100%', // match row height
          justifyContent: 'center',
          background: 'none !important',
          '&:hover': { background: 'none !important' },
          '&:active': { background: 'none !important' },
          '&.Mui-selected': {
            fontWeight: 500,
            color: '#3f51b5',
            fontSize: '1.5rem'
          }
        }
      }
    },

    MuiPickersMonth: {
      styleOverrides: {
        root: {
          flex: '1 0 33.33%', // 3 columns
          cursor: 'pointer',
          height: '75px', // match your desired row height
          display: 'flex',
          outline: 'none',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'font-size 100ms cubic-bezier(0.4, 0, 0.2, 1)'
        },
        monthButton: {
          width: '100%',
          height: '100%',
          fontSize: '1rem',
          fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
          fontWeight: 400,
          lineHeight: 1.75,
          letterSpacing: '0.00938em',
          color: 'inherit',
          background: 'none !important',
          border: 'none',
          outline: 'none',
          borderRadius: 0,
          cursor: 'pointer',
          margin: 0,
          '&:hover': {
            background: 'none !important'
          },
          '&:active': {
            background: 'none !important'
          },
          '&.Mui-selected': {
            color: '#3f51b5',
            fontWeight: 500,
            fontSize: '1.5rem',
            background: 'none !important'
          }
        }
      }
    },
    MuiPickersCalendarHeader: {
      styleOverrides: {
        root: {
          display: 'none',
          justifyContent: 'space-between'
        },
        labelContainer: {
          display: 'flex',
          justifyContent: 'center',
          flex: 1
        }
      }
    },
    MuiPickersDay: {
      styleOverrides: {
        day: {
          width: 36,
          height: 36,
          margin: '2px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        },
        weekDayLabel: {
          display: 'flex',
          maxHeight: 16,
          alignItems: 'center',
          justifyContent: 'center',
          color: 'rgba(0,0,0,0.38)',
          width: 36,
          margin: '0 2px',
          textAlign: 'center',
          fontSize: '0.85rem',
          fontWeight: 400,
          lineHeight: 1.43,
          letterSpacing: '0.01071em'
        }
      }
    },
    MuiPickersStaticWrapper: {
      styleOverrides: {
        root: {
          overflow: 'hidden'
        }
      }
    }
  }
});

export const Paper = styled(PaperBase)(() => ({
  minHeight: '450px',
  maxHeight: '450px',
  width: '320px',
  padding: 0,
  overflow: 'hidden',
  '@media (max-width:800px)': {
    width: '100%',
    margin: 0,
    justifyContent: 'center'
  }
}));

export const ButtonsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  padding: theme.spacing(2)
}));
